import React, {useState} from "react";

import {loginRequest} from "auth/authAzure";
import {deleteUser, editUser,} from "services/Graph.service";
import {i18n} from "translate/i18n";
import {deleteUsersDashboard, getDashboardUser, updateUsersDashboard} from "services/Users.service";

import {useMsal} from "@azure/msal-react";
import {useNavigate, useParams} from "react-router";
import {useMutation, useQuery, useQueryClient} from "react-query";

import FormUsers from './form';
import {swalBadRequest, swalQuestion, swalSuccess} from "components/Swal";

import Loading from "components/Loading";
import {toast} from "react-toastify";
import api from "../../../services/api";

const EditeUser = () => {

    const {instance, accounts} = useMsal();
    const navigate = useNavigate();
    const {id} = useParams();
    const [userData, setUserData] = useState({});

    const {data, isLoading, isFetching} = useQuery(["user", id],
        () => {
            return getDashboardUser(id)
        }, {
            onSuccess: (res) => {

                if (!res) {
                    navigate('/users/list')
                }

                const data = {
                    displayName: res.username,
                    accountEnabled: !!res.status,
                    profile: res.profile,
                    alternative_email: res.alternative_email,
                    email: res.email
                }

                setUserData(data)
            },
            onError: () => {
                toast.error(i18n.t('error.badRequest'));
                navigate('/users/list')
            },
            retry: false,
            refetchOnWindowFocus: false
        }
    )


    const queryClient = useQueryClient()
    // const rules = changeRules(values, userId)

    const userMutations = useMutation(async (rules) => {
            return api.put(`/dashboardUsers/${id}`, rules)
        }, {
            onSuccess: () => {
                toast.success(i18n.t('success.editUser'))
                queryClient.invalidateQueries('permissions')
                return navigate(`/redirect/users/${id}`)
            },
            onError: () => {
                toast.error(i18n.t('error.badRequest'));
            }
        }
    )

    const handleEdit = (values) => {

        swalQuestion(`<b>${i18n.t('questions.editUser')}</b>`).then(res => {
            if (res.isConfirmed) {
                //userMutations.mutate(rules)


                const dataDb = {
                    username: values.displayName,
                    alternative_email: values.alternative_email,
                    profile: values.profile,
                    status: values.accountEnabled,
                }

                console.log(dataDb)

                updateUsersDashboard(id, dataDb).then(response => console.log('update user dashboard', response));

                swalSuccess(i18n.t('success.editUser')).then(() => {
                    //return navigate(`/redirect/users/${id}`)
                })


                // instance.acquireTokenSilent({
                //     ...loginRequest,
                //     account: accounts[0]
                // }).then((response) => {
                //     // setLoading(true);
                //
                //     const data = {
                //         displayName: values.displayName,
                //         accountEnabled: values.accountEnabled
                //     }
                //
                //     editUser(response.accessToken, id, JSON.stringify(data)).then(async (response) => {
                //
                //         if (response.ok) {
                //
                //             const dataDb = {
                //                 username: values.displayName,
                //                 //alternative_email: values.alternative_email,
                //                 //profile: values.profile,
                //                 //status: values.accountEnabled,
                //             }
                //
                //             await updateUsersDashboard(id, dataDb).then(response => console.log('update user dashboard', response));
                //
                //             swalSuccess(i18n.t('success.editUser')).then(() => {
                //                 //return navigate(`/redirect/users/${id}`)
                //             })
                //
                //         } else {
                //             return swalBadRequest();
                //         }
                //     })
                // })

            }
        })

        // userMutations.mutate(rules)

        // const queryClient = useQueryClient()

        // const rules = changeRules(values, userId)
        //const data = setNewData(values)

        // updateUsersDashboard(userId, rules).then(response => console.log(response));

        /*        swalSuccess(i18n.t('alerts.successEditUser'))
                    .then(() => {
                        return navigate(`/redirect/users/${id}`)
                    })*/

        /*  instance.acquireTokenSilent({
              ...loginRequest,
              account: accounts[0]
          }).then((response) => {
             // setLoading(true);
              editUser(response.accessToken, id, JSON.stringify(data)).then(response => {

                  if (response.ok) {
                      updateUsersDashboard(id, rules).then(response => console.log(response));
                      swalSuccess(i18n.t('alerts.successEditUser'))
                          .then(() => { return navigate(`/redirect/users/${id}`) })
                  } else {
                      return swalBadRequest();
                  }
              })
          })*/
    }

    const handleDelete = (id) => {
        swalQuestion(`<b>${i18n.t('questions.deleteUser')}</b>`)
            .then((result) => {
                if (result.isConfirmed) {

                    instance.acquireTokenSilent({
                        ...loginRequest,
                        account: accounts[0]
                    }).then((response) => {

                        deleteUser(response?.accessToken, id).then(response => {

                            if (response) {
                                console.log('delete user', response)
                            }

                        });
                    })

                    deleteUsersDashboard(id).then(res => console.log('delete', res));
                    navigate('/users/list')
                }

            })
    }

    if (!data || isLoading || isFetching) return <Loading/>

    return <FormUsers
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        formValues={userData}
    />

}

export default EditeUser
